import React from 'react';
import styled, { css } from 'styled-components';
import { formatSaldo } from '../../utils/formatters';

const IndicatorCardStyled = styled.div`
  background-color: ${props => props.theme.colors.surface};
  padding: 1.5rem;
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: ${props => props.theme.shadows.soft};
  border-left: 5px solid ${props => props.color};
  min-width: 0;
  cursor: ${props => props.$clickable ? 'pointer' : 'default'};
  transition: box-shadow 0.15s;
  &:hover {
    box-shadow: ${props => props.$clickable ? '0 6px 16px rgba(0, 0, 0, 0.16)' : props.theme.shadows.soft};
  }
  /* Celular, cuando va de a dos por fila: más compacta. */
  ${props => props.$compactMobile && css`
    @media (max-width: 768px) {
      padding: 0.85rem 0.9rem;
      border-left-width: 4px;
    }
  `}
`;
const IndicatorTitle = styled.h3`
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${props => props.theme.colors.textSecondary};
  ${props => props.$compactMobile && css`
    @media (max-width: 768px) {
      font-size: 0.8rem;
      margin-bottom: 0.3rem;
    }
  `}
`;
const IndicatorValue = styled.p`
  margin: 0;
  font-size: ${props => props.$valueSize || '2rem'};
  font-weight: 700;
  color: ${props => props.color};
  overflow-wrap: anywhere;
  line-height: 1.2;
  ${props => props.$compactMobile && css`
    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
  `}
`;
const IndicatorSecondary = styled.p`
  margin: 0.35rem 0 0 0;
  font-size: 0.8rem;
  font-weight: 500;
  color: ${props => props.theme.colors.textSecondary};
  strong { font-weight: 700; }
`;

const IndicatorCard = ({ title, value, currency, color, valuePrefix = '', valueSize, secondaryLabel, secondaryValue, onClick, compactMobile = false }) => {
  const format = (value) => formatSaldo(value, currency);
  const hasSecondary = secondaryLabel || secondaryValue !== undefined;
  return (
    <IndicatorCardStyled
      color={color}
      $clickable={!!onClick}
      $compactMobile={compactMobile}
      onClick={onClick}
      title={onClick ? 'Click para ver detalle' : undefined}
    >
      <IndicatorTitle $compactMobile={compactMobile}>{title}</IndicatorTitle>
      <IndicatorValue color={color} $valueSize={valueSize} $compactMobile={compactMobile}>{valuePrefix}{format(value)}</IndicatorValue>
      {hasSecondary && (
        <IndicatorSecondary>
          {secondaryLabel}
          {secondaryValue !== undefined && <strong> {format(secondaryValue)}</strong>}
        </IndicatorSecondary>
      )}
    </IndicatorCardStyled>
  );
};

export default IndicatorCard;
